import { BaseError } from "./base.js";
export class EntryPointNotFoundError extends BaseError {
    constructor(chain) {
        super([
            `No default entry point exists for ${chain.name}.`,
            `Supply an override.`,
        ].join("\n"));
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "EntrypointNotFoundError"
        });
    }
}
//# sourceMappingURL=entrypoint.js.map